import http from "../http-common";

class AssignmentDataService {
  getAll() {
    return http.get("/authorui/assignments");
  }

  get(id) {
    return http.get(`/authorui/assignments/${id}`);
  }

  create(data) {
    return http.post("/authorui/assignments", data);
  }

  update(id, data) {
    return http.put(`/authorui/assignments/${id}`, data);
  }

  delete(id) {
    return http.delete(`/authorui/assignments/${id}`);
  }
}

export default new AssignmentDataService();
